/* eslint-disable */
import ko from 'knockout';
import _ from 'underscore';
import ko_schema from '@bingads-webui-component-legacy/ko-schema/index';
import config from '@bingads-webui-component-legacy/config/index';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
var s$AdGroup = window.globalLegacySchema.get('AdGroup');
var viewModel = function (options) {
  var self = this;
  self.options = options || ({});
  self.properties = _.keys(s$AdGroup.properties);
  ko_schema.properties(self, s$AdGroup, self.properties);
  var campaign = self.options.context.get('Campaign');
  self.isOpen = ko.observable(true);
  self.isOnlyAdGroup = ko.observable(false);
  self.Name('');
  self.Campaign({
    Id: campaign.Id
  });
  self.CampaignName(campaign.Name);
  self.Language(campaign.Language);
  self.StartDate(campaign.StartDate);
  self.EndDate(campaign.EndDate);
  self.isWaitingForSaveResponse = ko.observable(false);
  self.isNameDuplicate = ko.observable(false);
  self.shouldValidateName = ko.observable(false);
  self.isDeleted = ko.observable(false);
  self.suggestedAvgCpc = ko.observable();
  self.deletedConfirmationMessage = ko.computed(function () {
    if (self.isDeleted()) {
      return i18n.get('AdGroup_Message_DeletedConfirmation') + ' ' + self.Name();
    }
    return '';
  });
  self.removeButtonLabel = ko.computed(function () {
    return i18n.get('AdGroup_Label_RemoveButton') + ' ' + self.Name();
  });
};
export default viewModel;

